export enum SearchTypeValues {
  None,
  Content,
  Grid,
}
